import React, { useEffect, useState } from "react";

export default function BrandCard({ nom }) {
  const [imageFound, setImageFound] = useState(null);

  useEffect(() => {
    const name = nom?.toLowerCase().replace(/\s/g, "-");
    const basePath = `/assets/${name}`;
    const extensions = [".webp", ".png", ".jpg", ".jpeg"];
    let isMounted = true;

    const tryImages = async () => {
      for (let ext of extensions) {
        const url = `${basePath}${ext}`;
        const img = new Image();
        img.src = url;
        img.onload = () => {
          if (isMounted) setImageFound(url);
        };
      }
    };
    tryImages();

    return () => {
      isMounted = false;
    };
  }, [nom]);

  return (
    <div className="bg-white rounded shadow-sm p-4 text-center h-100">
      {imageFound ? (
        <img
        loading="lazy"
          src={imageFound}
          alt={`Logo ${nom}`}
          style={{ height: "50px", objectFit: "contain", marginBottom: "12px" }}
        />
      ) : (
        <div className="text-primary mb-2" style={{ fontSize: "2rem" }}>
          <i className="bi bi-car-front"></i>
        </div>
      )}
      <h6 className="fw-semibold m-0">{nom}</h6>
    </div>
  );
}
